import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import {MatNativeDateModule, MatRippleModule, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import { BackendService } from './shared/backend.service';
import { PaginationComponent } from './shared/pagination.component';
import { PaginationService } from './shared/pagination.service';
import { OrderByService } from './shared/orderby.service';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatStepperModule,
  DateAdapter,
  
  
} from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AuthService } from './shared/auth.service';
// import { LoadingService } from './loading-spinner/loading.service';
// import { LoadingComponent } from './loading-spinner/loading.component';
//import { NotificationComponent } from './notification/notification.component';
//import { NotificationService } from './notification/notification.service';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import {DatePipe} from '@angular/common';
import { MainpageComponent } from './mainpage/mainpage.component';

import { FAQComponent } from './menu-items/faq/faq.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { FileTransferComponent } from './menu-items/file-transfer/file-transfer.component';
import { DataEntryComponent } from './menu-items/data-entry/data-entry.component';
import { DataEntryAccountEditComponent } from './menu-items/data-entry/dataentry-accountedit.component';
import { DataEntryDASubmissionComponent } from './menu-items/data-entry/dataentry-dasubmission.component';
import { PostNoAccountsComponent } from './menu-items/post-no-accounts/post-no-accounts.component';
import { ViewSubmissionsComponent } from './menu-items/view-submissions/view-submissions.component';
import { SupportComponent } from './menu-items/support/support.component';
import { AuthGuard } from './shared/auth.guard';
import { PopupdisplayComponent } from './popupdisplay/popupdisplay.component';
import { FilterService } from './shared/filter.service';
import { NotificationComponent } from './notification/notification.component';
import { ResetQuestionsComponent } from './reset-questions/reset-questions.component';
import { ProfileComponent } from './profile/profile.component';
import { PasswordResendComponent } from './login/password-resend.component';
import { NotificationService } from './notification.service';
import { LoadingComponent } from './loading-spinner/loading.component';
import { TimeoutComponent } from './timeout/timeout.component';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ViewimportauditComponent } from './viewimportaudit/viewimportaudit.component';
import { ViewsubmissioncontainerComponent } from './viewsubmissioncontainer/viewsubmissioncontainer.component';
import { DocumentsComponent } from './documents/documents.component';
import { AlertmessageService } from './shared/alertmessage.service';
import { AllservicesService } from './shared/allservices.service';

import { ConfirmComponent } from './viewimportaudit/confirm/confirm.component';
import { AdminaccessComponent } from './adminaccess/adminaccess.component';
//import { NotificationService } from './shared/notification.service';
 //import { NotificationService } from './notification.service';




@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,    
    MainpageComponent,    
    FAQComponent,
    ChangePasswordComponent,   
    FileTransferComponent,
    DataEntryComponent,
    PostNoAccountsComponent,
    ViewSubmissionsComponent,
    SupportComponent,
    //LoadingComponent,
    NotificationComponent,
    PaginationComponent,
    DataEntryAccountEditComponent,
    DataEntryDASubmissionComponent,
    PopupdisplayComponent,
    ResetQuestionsComponent,
    ProfileComponent,
    PasswordResendComponent,
    LoadingComponent,
    TimeoutComponent,
    ViewimportauditComponent,
    ViewsubmissioncontainerComponent,
    DocumentsComponent,
    ConfirmComponent,
    AdminaccessComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule, 
    ReactiveFormsModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    HttpModule,
    HttpClientModule,
     //material modules
     MatAutocompleteModule, 
     MatButtonModule,
     MatButtonToggleModule,
     MatCardModule,
     MatCheckboxModule,
     MatChipsModule,
     MatTableModule,
     MatDatepickerModule,
     MatDialogModule,
     MatExpansionModule,
     MatFormFieldModule,
     MatGridListModule,
     MatIconModule,
     MatInputModule,
     MatListModule,
     MatMenuModule,
     MatPaginatorModule,
     MatProgressBarModule,
     MatProgressSpinnerModule,
     MatRadioModule,
     MatRippleModule,
     MatSelectModule,
     MatSidenavModule,
     MatSlideToggleModule,
     MatSliderModule,
     MatSnackBarModule,
     MatSortModule,
     MatStepperModule,
     MatTabsModule,
     MatToolbarModule,
     MatTooltipModule,
     MatNativeDateModule, 
     DeviceDetectorModule.forRoot(),
     NgIdleKeepaliveModule.forRoot(),
     ModalModule.forRoot(),
     
   
  ],
  providers: [   
    AuthService,
    BackendService,    
   // LoadingService,
    NotificationService,
    OrderByService,
    PaginationService,
    FilterService,
    AuthGuard,
    AlertmessageService,
    AllservicesService,

    {provide:MAT_DIALOG_DATA,useValue:{}},
    { provide: MatDialogRef, useValue: {} }
   // {provide: LocationStrategy, useClass: HashLocationStrategy},    
  ],
  entryComponents: [DataEntryAccountEditComponent, DataEntryDASubmissionComponent,DataEntryComponent,PopupdisplayComponent,ConfirmComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
